module.exports = __webpack_public_path__ + "img/list-2.105e58b7.png";